<script setup lang="ts">
	import type { ImplementV2Model } from "@ptx-autonomous/libs/flightpath-service-api";

	defineProps<{
		allImplements: ImplementV2Model[];
		isLoadingImplements: boolean;
	}>();

	const emits = defineEmits<{
		resetOmnibar: [void];
		selectImplement: [ImplementV2Model];
	}>();
</script>

<template>
	<div
		class="flex items-center justify-between p-4 bg-green-50 border-b border-green-200"
	>
		<div>
			<h3 class="title text-green-800 text-lg font-semibold">
				Select Implement
			</h3>
		</div>
		<button
			@click="emits('resetOmnibar')"
			class="text-grey-400 hover:text-grey-600"
		>
			<svg
				class="w-5 h-5"
				fill="none"
				stroke="currentColor"
				viewBox="0 0 24 24"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="2"
					d="M6 18L18 6M6 6l12 12"
				></path>
			</svg>
		</button>
	</div>
	<div class="max-h-80 overflow-y-auto space-y-2 p-4">
		<div
			v-if="isLoadingImplements"
			class="text-center py-8 text-grey-600"
		>
			<div
				class="animate-spin rounded-full h-6 w-6 border-2 border-green-50 border-b-2 border-b-green-600 mx-auto mb-3"
			></div>
			<div class="text-sm font-medium">Loading implements...</div>
		</div>
		<div
			v-else-if="!allImplements || allImplements.length === 0"
			class="text-center py-4 text-grey-500"
		>
			No implements available
		</div>
		<template v-if="!isLoadingImplements">
			<button
				v-for="implement in allImplements"
				:key="implement.ImplementId"
				@click="emits('selectImplement', implement)"
				class="w-full text-left p-3 rounded-lg border border-grey-200 hover:border-green-600 hover:bg-green-50 transition-colors"
			>
				<div class="font-medium text-grey-950">
					{{ implement.ImplementName || "Unnamed Implement" }}
				</div>
				<div class="text-sm text-grey-500">
					Width:
					{{
						implement.Sections?.[0]?.ElementWorkingWidth
							? `${(implement.Sections[0].ElementWorkingWidth * 3.28084).toFixed(1)} ft`
							: "Unknown"
					}}
				</div>
			</button>
		</template>
	</div>
</template>
